import { DarkMode } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { isBrandLook } from "theme/look";

/**
 * The legacy header is dark in both colour modes; the brand-look header
 * follows the colour mode (white in light mode, like intentsify.io).
 */
export const TopBarColorMode = ({ children }: PropsWithChildren) =>
  isBrandLook ? <>{children}</> : <DarkMode>{children}</DarkMode>;
